export default "__VITE_ASSET__CCqaVZFt__"